import { render, staticRenderFns } from "./firstGoodsAction.vue?vue&type=template&id=55d6865f&scoped=true"
import script from "./firstGoodsAction.vue?vue&type=script&lang=js"
export * from "./firstGoodsAction.vue?vue&type=script&lang=js"
import style0 from "./firstGoodsAction.vue?vue&type=style&index=0&id=55d6865f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d6865f",
  null
  
)

export default component.exports